module.exports = __webpack_public_path__ + "static/img/Liquid Silicone Rubber for  Food Kitchen.82f6c3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Liquid Silicone Rubber for  Food Kitchen.jpg
// module id = Gbsb
// module chunks = 1